<template>
<div>
<div class="g_dialogw" :class="{'g_dialogw_active': showPanel}">
</div>
<div class="iconwrapper g_panel g_dialog" @click.stop :class="{ 'darkmode': darkMode}"  role="presentation">
  <!-- header -->
  <div class="header g_panel-header">
    <span class="back icon-back" role="button" aria-label="back" tabindex="0" v-if="this.showIcons" @click.stop="backHandler" />
    <div class="close icon-del" role="button" aria-label="back" tabindex="1" v-else @click.stop="togglePanel"></div>
    <h1 class="title">
      {{this.showIcons ? `${$t('iconPanel.title2')}` : `${$t('iconPanel.title')}`}}
    </h1>
  </div>
  <!-- end header -->
  <div class="iconlistw g_scroll">
    <Loading v-if="loading"/>
    <div class="nodata" v-if="(!showIcons && iconSets && !iconSets.length) || (showIcons && !icons)">{{showIcons ?  `${$t('iconPanel.noIcon')}` :  `${$t('iconPanel.noIconSet')}`}}</div>
    <ul class="iconlist g_clearfix" v-if="!showIcons && !loading">
      <li class="item" :key="item._id" v-for="item in iconSets">
        <span class="item-iconw"
          @click.stop="chooseIconSet(item)"
          role='button'
          :aria-label="item.name"
          :tabIndex="0">
          <img class="item-icon" :src="`${HttpRoot}${item.icon}`" :alt="item.name"/>
          <p class="item-name">{{item.name}}</p>
        </span>
      </li>
    </ul>
    <ul class="iconlist g_clearfix iconlist_icons" v-if="showIcons">
      <li class="item" :key="index" v-for="(item, index) in icons">
        <span class="item-iconw"
          @click.stop="chooseIconHandler(item)"
          role='button'
          :aria-label="item"
          :tabIndex="0">
          <img class="item-icon" :src="`${HttpRoot}${item}`" alt="图标"/>
        </span>
      </li>
    </ul>
  </div>
</div>
</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import Loading from '@/components/Loading'
import { HttpRoot } from '@/config/'

export default {
  components: {
    Loading,
  },
  data() {
    return {
      hide: true,
      HttpRoot,
      loading: false,
      title: '选择图标集',
      showIcons: false,
      icons: [],
    }
  },
  computed: {
    ...mapState({
      iconSets: state => state.icon.iconSets,
      showPanel: state => state.icon.showPanel,
      user: state => state.user.user,
    }),
  },
  mounted() {
    this.getIcons().then(() => {
      this.loading = false
    })
  },
  watch: {
    showPanel(val) {
      if (val) {
        this.showIcons = false
        document.addEventListener('click', this.togglePanel, false)
      } else {
        document.removeEventListener('click', this.togglePanel)
      }
    },
  },
  methods: {
    ...mapMutations({
      togglePanel: 'icon/togglePanel',
      chooseIcon: 'icon/chooseIcon',
      showUpgrade: 'showUpgrade',
    }),
    ...mapActions({
      getIcons: 'icon/getIcons',
    }),
    backHandler() {
      if (this.showIcons) {
        this.showIcons = false
      } else {
        this.togglePanel()
      }
    },
    chooseIconSet(item) {
      console.log(this.user)
      if (!this.user.isMember) {
        this.showUpgrade()
        return
      }
      this.showIcons = true
      this.icons = item.icons
    },
    chooseIconHandler(icon) {
      this.chooseIcon(icon)
      this.togglePanel()
    },
  },
}
</script>

<style lang="scss" scoped>
.iconlistw{
  height: 398px;
  margin-top: 0.5px;
  // width: 400px;
}
.iconwrapper{
  // width: 260px;
  height: 450px;
  width: 350px;
  position: absolute;
  z-index: 100;
  border: 1px solid rgba(195, 195, 195, 0.5);
  border-radius: 8px;
  overflow: hidden;
  // box-shadow: 0 0 14px rgba(70, 69, 69, 0.1);
  box-shadow: 0 0 14px rgba(36, 36, 36, 0.3);
  .header{
    .title{
      font-weight: bold;
    }
    .header-icon{
      width: 14px;
      height: 14px;
      margin-right: 6px;
      vertical-align: middle;
    }
  }
}
.iconlist{
  padding: 10px;
  min-height: 320px;
  overflow:hidden;
  position: relative;
  .item{
    float: left;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    padding-bottom: 4px;
    &:hover{
      background: #eee;
    }
  }
  .item-iconw{
    display: block;
    width: 110px;
    // height: 70px;
    // padding: 10px;
    line-height: 40px;
  }
  .item-icon{
    width: 60px;
    display: block;
    margin: 10px auto 10px;
  }
  .item-name{
    text-align: center;
    font-size: 14px;
    line-height: 16px;
  }
}
.nodata{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  height: 320px;
  line-height: 320px;
  text-align: center;
  color: #DCDCDC;
  font-size: 18px;
  margin: auto;
  margin-top: 40px;
  // background: #fff;
}
.iconlist_icons{
  // position: absolute;
  // left: 0;
  // top: 40px;
  background: #fff;
  .item-iconw{
    display: flex;
    align-items: center;
  }
}
.license{
  padding: 4px;
  font-size: 12px;
  color: #b5b5b5;
  border-radius: 4px;
  background: #f5f5f5;
  margin: 4px 8px;
  a{
    color: #b5b5b5;
    text-decoration: unset;
    color: #a0a0a0;
  }
}
.license-inner{
  transform: scale(0.8);
}

/** bigmode */
.bigmode{
  .item-icon{
    width: 46px;
  }
  .iconlist .item-iconw{
    width:88px;
  }
}

/**  darkmode **/
.darkmode{
  background: #292929;
  border: 1px solid rgb(68,67,66);
  .item{
    &:hover{
        background: #5C5B5B;
    }
  }
  .item-name{
    color: #fff;
  }
  .iconlist_icons{
    background: none;
  }
  .nostars{
    color: #737373;
  }
}
</style>
